"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringValuesSelector = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _emotion = require("emotion");

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _Checkbox = _interopRequireDefault(require("@cimpress/react-components/lib/Checkbox"));

var _SelectWrapper = _interopRequireDefault(require("@cimpress/react-components/lib/SelectWrapper"));

var _styles = _interopRequireDefault(require("@cimpress/react-components/lib/Select/styles"));

var _options = require("../../shared/enums/options");

var _propTypes2 = require("../../shared/propTypes");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .form-group {\n    input {\n      transition: inherit;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SET_VALUE_ACTION = 'set-value';
var stringValuesSelectorStyle = (0, _emotion.css)(_templateObject());

var StringValuesSelector = function StringValuesSelector(_ref) {
  var selectedValues = _ref.selectedValues,
      availableValues = _ref.availableValues,
      onSelectedValuesChanged = _ref.onSelectedValuesChanged;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      updateOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOptions = _useState4[0],
      updateSelectedOptions = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchText = _useState6[0],
      updateSearchText = _useState6[1];

  (0, _react.useEffect)(function () {
    var optionsHash = availableValues ? generateOptionsHash(availableValues) : generateOptionsHash(selectedValues);
    updateOptions(optionsHash);
  }, [availableValues, selectedValues]);
  (0, _react.useEffect)(function () {
    var selected = selectedValues.map(function (value) {
      return options[value.value];
    }).filter(function (value) {
      return value;
    });
    updateSelectedOptions(selected);
  }, [options, selectedValues]);

  var onSelectionsChanged = function onSelectionsChanged(updatedSelections) {
    onSelectedValuesChanged(updatedSelections.map(function (selection) {
      return selection.value;
    }));
  };

  var onSearchTextChanged = function onSearchTextChanged(updatedSearchText, _ref2) {
    var action = _ref2.action;

    if (action !== SET_VALUE_ACTION) {
      updateSearchText(updatedSearchText);
    }
  };

  var props = {
    id: 'StringValuesSelector',
    placeholder: availableValues ? formatMessage(_messages["default"].selectValuesLabel) : formatMessage(_messages["default"].addValuesLabel),
    value: selectedOptions,
    options: Object.values(options),
    components: {
      Option: StringValueCheckbox
    },
    hideSelectedOptions: false,
    controlShouldRenderValue: false,
    closeMenuOnSelect: false,
    backspaceRemovesValue: false,
    tabSelectsValue: false,
    isMulti: true,
    onChange: onSelectionsChanged,
    filterOption: filterFunc,
    getNewOptionData: getNewValue,
    createOptionPosition: 'first',
    styles: _styles["default"],
    inputValue: searchText,
    onInputChange: onSearchTextChanged,
    'data-testid': 'StringValuesSelector'
  };
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)(stringValuesSelectorStyle)
    },
    /*#__PURE__*/
    _react["default"].createElement(_SelectWrapper["default"], _extends({
      selectedSelect: availableValues ? _reactSelect["default"] : _creatable["default"]
    }, props)))
  );
};

exports.StringValuesSelector = StringValuesSelector;
StringValuesSelector.propTypes = {
  selectedValues: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)),
  availableValues: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)),
  onSelectedValuesChanged: _propTypes["default"].func.isRequired
};
StringValuesSelector.defaultProps = {
  selectedValues: []
};

function generateOptionsHash(values) {
  return values.reduce(function (hash, value) {
    return _objectSpread(_objectSpread({}, hash), {}, _defineProperty({}, value.value, {
      label: value.value,
      value: value
    }));
  }, {});
}

function filterFunc(option, searchText) {
  var optionLabel = option.label.toLowerCase();
  var probe = searchText.toLowerCase();
  return optionLabel.indexOf(probe) > -1;
}

function StringValueCheckbox(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactSelect.components.Option, _extends({}, props, {
      isSelected: false
    }),
    /*#__PURE__*/
    _react["default"].createElement(_Checkbox["default"], {
      label: props.label,
      checked: props.isSelected
    }))
  );
}

function getNewValue(inputText, optionLabel) {
  return {
    label: optionLabel,
    value: {
      type: _options.VALUE,
      value: inputText
    }
  };
}